// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ServicesTabs-module--tabs--PmHLL","tabsInner":"ServicesTabs-module--tabsInner--1_QEL","tab":"ServicesTabs-module--tab--1mPc1","active":"ServicesTabs-module--active--2__mW"};